var Intervalle_Req_Mini_NTP = 10;										//Synchro toutes les XX secondes													

var Burst_Initial = 20;			//Pour acc�l�rer la synchro initiale. Plus grand que Taille_Filtre_NTP
var Taille_Filtre_NTP = 10;		//Nombre de case pour le moyennage des offsets NTP. 			

//Intervalle de rafraichissement de l'affichage de l'horloge (msec)
var Intervalle_MAJ = 50;

//Couleur de fond
var FillStyle_Fond = "rgba(255, 255, 255, 0)";	//A coordoner avec le div en d�but de html		

//Nombre de LEDs par segments
var Seg_LEDs = 4;							// 3 ou 4

//Logo Gorgy Timing
var Logo_GT = false;						//true = montrer, false = ne pas montrer.
var Logo_File = "logo-gt.png";				//Fichier image
var Logo_Width = 0.50;						//Largeur ajustable du logo, en pourcentage de la largeur totale (la hauteur est automatique)
var Logo_Y = 0.68;							//Position en hauteur du logo, en pourcentage depuis le haut
var Logo_X = document.getElementById('GT_LEDI').offsetWidth * (1 - Logo_Width) / 2;	//Logo centr�

//Texte custom
var Cust_txt = ""				//Affichage d'un texte si la chaine n'est pas vide
var Cust_txt_font = "10px Verdana";			//Police du texte
var Cust_txt_color = "#ff8888";				//Couleur du texte
var Cust_txt_pos = 0.75						//Position en hauteur du texte, en pourcentage depuis le haut

//Couleurs des LED (chiffres & vagues)	   
//Note : couleurs LED si ON, LED si OFF, Strk = le contour de la LED
//Note : plus l'hologe est grande, plus la couleur 'OFF' doit �tre sombre				   

//Rouge
// var Col_Vag_ON = color;
// var Col_Vag_OFF = color2;
// var Col_Vag_Strk = stroke;
var Col_Vag_ON = "#e30613";
var Col_Vag_OFF = "rgba(255, 0, 0, 0)";
var Col_Vag_OFF_BIS = "#400000";
var Col_Vag_Strk = "#e30613";

//Temps serveur			  
var CurrentDate = new Date();
var Srv_Date = new Date();
var Orig_Date = new Date();
var Srv_Offset = new Date(0);


//Variables
var Offsets_Table = new Array();
var http_rq;
var Cur_Millisec;
var Req_Time;
var CurSec = 0;
var Last_Sec = 0;
var Last_Demi_Sec = 0;
var canvas;
var context;
var Clock_Center_X;
var Clock_Center_Y;
var Rayon_Vague_Ext;
var Rayon_Vague;
var Seg_Len;
var Rayon_LED;
var logo_image;

//Définition des chiffres
var Dig_0 = new Array(1, 1, 1, 1, 1, 1, 0);
var Dig_1 = new Array(0, 1, 1, 0, 0, 0, 0);
var Dig_2 = new Array(1, 1, 0, 1, 1, 0, 1);
var Dig_3 = new Array(1, 1, 1, 1, 0, 0, 1);
var Dig_4 = new Array(0, 1, 1, 0, 0, 1, 1);
var Dig_5 = new Array(1, 0, 1, 1, 0, 1, 1);
var Dig_6 = new Array(1, 0, 1, 1, 1, 1, 1);
var Dig_7 = new Array(1, 1, 1, 0, 0, 0, 0);
var Dig_8 = new Array(1, 1, 1, 1, 1, 1, 1);
var Dig_9 = new Array(1, 1, 1, 1, 0, 1, 1);
var Digits = new Array(Dig_0, Dig_1, Dig_2, Dig_3, Dig_4, Dig_5, Dig_6, Dig_7, Dig_8, Dig_9);

//URL Call
var Serveur_Temps = "/horloge";

var Compteur_Req = 0;
var Dont_Display_OFF_Stroke = true;

LEDI_Init_Vars();

function LEDI_Init_Vars() {

    //Traitement du canvas
    canvas = document.getElementById('LEDI_Canvas');
    context = canvas.getContext('2d');

    //Report des dimensions
    canvas.height = canvas.offsetHeight;
    canvas.width = canvas.offsetWidth;

    //Centre de l'horloge		
    Clock_Center_X = canvas.height / 2;
    Clock_Center_Y = canvas.width / 2;

    //Vague	 		
    Rayon_Vague_Ext = (canvas.width * 0.90) / 2;
    Rayon_Vague = (canvas.width * 0.80) / 2;

    //Rayon_LED																	  								
    Seg_Len = 10 * (Rayon_Vague / 36);

    if (Seg_LEDs == 3)	//3 LEDs
    {
        Rayon_LED = (Seg_Len / 4) * 0.5;
    }
    else				//4 LEDs
    {
        Rayon_LED = (Seg_Len / 11);
    }

    //Logo GT
    // logo_image = new Image();
    // logo_image.src = Logo_File;

    //Table d'offsets NTP	
    for (var i = 0; i < Taille_Filtre_NTP; i++) { Offsets_Table.push(0); }

    //Callback de MAJ de l'affichage
    setInterval(function () { Upd_Clock() }, Intervalle_MAJ);
}

function Draw_Clk() {

    //Dessin
    //------

    //Remplissage du fond
    context.fillStyle = FillStyle_Fond;
    context.clearRect(0, 0, canvas.width, canvas.height);

    //Vague Extérieure
    for (i = 0; i < 60; i += 5) {
        //Position en X Y
        sec_x = Rayon_Vague_Ext * Math.cos((i - 15) * 2 * Math.PI / 60);
        sec_y = Rayon_Vague_Ext * Math.sin((i - 15) * 2 * Math.PI / 60);

        //dessin du point
        context.beginPath();
        context.arc(sec_x + Clock_Center_X, sec_y + Clock_Center_Y, Rayon_LED, 0, 2 * Math.PI, false);

        //if( i<= CurrentDate.getSeconds())
        if (1) {
            context.fillStyle = Col_Vag_ON;
        }
        else {
            context.fillStyle = Col_Vag_OFF;
        }

        context.fill();
        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        context.stroke();

    }

    //Vague Intérieure
    for (i = 0; i < 60; i++) {
        //Position en X Y
        sec_x = Rayon_Vague * Math.cos((i - 15) * 2 * Math.PI / 60);
        sec_y = Rayon_Vague * Math.sin((i - 15) * 2 * Math.PI / 60);

        //dessin du point
        context.beginPath();
        context.arc(sec_x + Clock_Center_X, sec_y + Clock_Center_Y, Rayon_LED, 0, 2 * Math.PI, false);

        if (i <= CurrentDate.getSeconds()) {
            context.fillStyle = Col_Vag_ON;
            context.fill();

            context.lineWidth = 1;
            context.strokeStyle = Col_Vag_Strk;
            context.stroke();

        }
        else {
            context.fillStyle = Col_Vag_OFF;
            context.fill();

            if (Dont_Display_OFF_Stroke == false) {
                context.lineWidth = 1;
                context.strokeStyle = Col_Vag_Strk;
                context.stroke();
            }

        }

    }

    //Digits
    Draw_Digit(1, parseInt(CurrentDate.getHours() / 10));
    Draw_Digit(2, parseInt(CurrentDate.getHours() % 10));
    Draw_Digit(4, parseInt(CurrentDate.getMinutes() / 10));
    Draw_Digit(5, parseInt(CurrentDate.getMinutes() % 10));

    //Image si nécessaire
    if (Logo_GT == true) {
        context.drawImage(logo_image, Logo_X, Logo_Y * 2 * Clock_Center_Y, 2 * Clock_Center_X * Logo_Width, 2 * Clock_Center_X * Logo_Width * logo_image.height / logo_image.width)
    }

    //Message si nécessaire
    if (Cust_txt != '') {
        context.font = Cust_txt_font;
        context.fillStyle = Cust_txt_color;
        context.textAlign = "center";
        context.fillText(Cust_txt, Clock_Center_X, Clock_Center_Y * 2 * Cust_txt_pos);
    }

}

function Upd_Clock() {

    CurrentDate = new Date();
    CurrentDate.setTime(CurrentDate.getTime() + Srv_Offset.getTime());

    CurSec = CurrentDate.getSeconds();
    Cur_Millisec = CurrentDate.getMilliseconds();

    //MAJ de l'horloge si besoin
    if (CurSec != Last_Sec) {

        Last_Sec = CurSec;

        //Nouvelle seconde
        Compteur_Req--;

        if (Compteur_Req <= 0 || Burst_Initial > 0) {
            //Reload le compteur
            Compteur_Req = Intervalle_Req_Mini_NTP;

            //Sent NTP Request
            sendReq(Serveur_Temps);

            //Pour DEBUG
            //console.log('Envoie d\'une req NTP');

            Burst_Initial--;
        }

        if (CurrentDate != "") {
            Draw_Clk();
        }

        // Outils de DEBUG 
        //context.font = "10px Verdana";
        //context.fillStyle = "lime";
        //context.textAlign = "left";
        //context.fillText(Srv_Offset.getTime(),50,100);

    }

    //Mise à jour des deux points si besoin
    if ((Cur_Millisec < 500) != Last_Demi_Sec) {
        Last_Demi_Sec = (Cur_Millisec < 500);
        Draw_DP();
    }

}

function sendReq(url) {

    http_rq = new XMLHttpRequest();
    http_rq.onreadystatechange = handleResponse;

    Req_Time = new Date();

    http_rq.open('GET', url + "?ts=" + Req_Time.getTime(), true);
    http_rq.send(null);

}

function handleResponse() {

    Req_Time = new Date();

    if (http_rq.readyState == 4 && http_rq.status == 200) {
        // console.log(http_rq.responseText);
        json_data = JSON.parse(http_rq.responseText);
        eval(json_data.data);

        //Pour DEBUG
        // console.log('Réponse serveur : ' + http_rq.responseText );

        //Maintenant, NTP magic !
        Srv_Offset.setTime(((Srv_Date.getTime() - Orig_Date.getTime()) + (Srv_Date.getTime() - Req_Time.getTime())) / 2)

        //Pour DEBUG		
        //console.log('Calcul NTP : '+ Srv_Date.getTime() + ' , ' + Orig_Date.getTime() + ' , ' + Srv_Date.getTime() + ' , ' + Req_Time.getTime())

        //Petit filtrage
        Offsets_Table.shift();
        Offsets_Table[Taille_Filtre_NTP] = Srv_Offset.getTime();
        Srv_Offset.setTime((Offsets_Table.reduce((acc, valc) => acc + valc, 0)) / Taille_Filtre_NTP)

    }

}

function Draw_Digit(digit_nb, digit_val) {

    var Fill_Col = Col_Vag_OFF;
    var digit_x = 0;

    switch (digit_nb) {
        case 2:

            digit_x = -7 * (Rayon_Vague / 24);

            break;

        case 1:

            digit_x = - 2 * (Rayon_Vague / 3);

            break;

        case 4:

            digit_x = 7 * (Rayon_Vague / 24);

            break;

        case 5:

            digit_x = 2 * Rayon_Vague / 3;

            break;
    }



    //Segment 0 (Haut)
    if (Digits[digit_val][0]) {
        Fill_Col = Col_Vag_ON;
    }
    else {
        Fill_Col = Col_Vag_OFF;
    }

    //Dessin des points

    //Segment à 3 LEDs
    if (Seg_LEDs == 3) {

        context.beginPath();
        context.arc(Clock_Center_X + digit_x + (0.18 * Seg_Len) - 5 * Seg_Len / 18, Clock_Center_Y - Seg_Len, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }

        context.beginPath();
        context.arc(Clock_Center_X + digit_x + (0.18 * Seg_Len), Clock_Center_Y - Seg_Len, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }

        context.beginPath();
        context.arc(Clock_Center_X + digit_x + (0.18 * Seg_Len) + 5 * Seg_Len / 18, Clock_Center_Y - Seg_Len, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }
    }
    else	//Segment à 4 LEDs
    {

        context.beginPath();
        context.arc(Clock_Center_X + digit_x + (0.18 * Seg_Len) - 1 * Seg_Len / 9, Clock_Center_Y - Seg_Len, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }

        context.beginPath();
        context.arc(Clock_Center_X + digit_x + (0.18 * Seg_Len) - 3 * Seg_Len / 9, Clock_Center_Y - Seg_Len, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }

        context.beginPath();
        context.arc(Clock_Center_X + digit_x + (0.18 * Seg_Len) + 1 * Seg_Len / 9, Clock_Center_Y - Seg_Len, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }

        context.beginPath();
        context.arc(Clock_Center_X + digit_x + (0.18 * Seg_Len) + 3 * Seg_Len / 9, Clock_Center_Y - Seg_Len, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }

    }


    //Segment 1 (NE)
    if (Digits[digit_val][1]) {
        Fill_Col = Col_Vag_ON;
    }
    else {
        Fill_Col = Col_Vag_OFF;
    }
    //dessin des points

    //Segment à 3 LEDs
    if (Seg_LEDs == 3) {
        context.beginPath();
        context.arc(Clock_Center_X + digit_x + Seg_Len / 2 + 0.132 * Seg_Len, Clock_Center_Y - 14 * Seg_Len / 18, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }

        context.beginPath();
        context.arc(Clock_Center_X + digit_x + Seg_Len / 2 + 0.088 * Seg_Len, Clock_Center_Y - Seg_Len / 2, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }

        context.beginPath();
        context.arc(Clock_Center_X + digit_x + Seg_Len / 2 + 0.044 * Seg_Len, Clock_Center_Y - 4 * Seg_Len / 18, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }
    }
    else	//Segment à 4 LEDs
    {

        context.beginPath();
        context.arc(Clock_Center_X + digit_x + Seg_Len / 2 + 0.15 * Seg_Len, Clock_Center_Y - Seg_Len / 2 - 3 * Seg_Len / 9, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }

        context.beginPath();
        context.arc(Clock_Center_X + digit_x + Seg_Len / 2 + 0.11 * Seg_Len, Clock_Center_Y - Seg_Len / 2 - 1 * Seg_Len / 9, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }

        context.beginPath();
        context.arc(Clock_Center_X + digit_x + Seg_Len / 2 + 0.07 * Seg_Len, Clock_Center_Y - Seg_Len / 2 + 1 * Seg_Len / 9, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }

        context.beginPath();
        context.arc(Clock_Center_X + digit_x + Seg_Len / 2 + 0.03 * Seg_Len, Clock_Center_Y - Seg_Len / 2 + 3 * Seg_Len / 9, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }

    }




    //Segment 2 (SE)
    if (Digits[digit_val][2]) {
        Fill_Col = Col_Vag_ON;
    }
    else {
        Fill_Col = Col_Vag_OFF;
    }

    //dessin des points

    //Segment à 3 LEDs
    if (Seg_LEDs == 3) {
        context.beginPath();
        context.arc(Clock_Center_X + digit_x + Seg_Len / 2 - 0.132 * Seg_Len, Clock_Center_Y + 14 * Seg_Len / 18, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }

        context.beginPath();
        context.arc(Clock_Center_X + digit_x + Seg_Len / 2 - 0.088 * Seg_Len, Clock_Center_Y + Seg_Len / 2, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }

        context.beginPath();
        context.arc(Clock_Center_X + digit_x + Seg_Len / 2 - 0.044 * Seg_Len, Clock_Center_Y + 4 * Seg_Len / 18, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }

    }
    else	//Segment à 4 LEDs
    {

        context.beginPath();
        context.arc(Clock_Center_X + digit_x + Seg_Len / 2 - 0.03 * Seg_Len, Clock_Center_Y + Seg_Len / 2 - 3 * Seg_Len / 9, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }

        context.beginPath();
        context.arc(Clock_Center_X + digit_x + Seg_Len / 2 - 0.07 * Seg_Len, Clock_Center_Y + Seg_Len / 2 - 1 * Seg_Len / 9, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }

        context.beginPath();
        context.arc(Clock_Center_X + digit_x + Seg_Len / 2 - 0.11 * Seg_Len, Clock_Center_Y + Seg_Len / 2 + 1 * Seg_Len / 9, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }

        context.beginPath();
        context.arc(Clock_Center_X + digit_x + Seg_Len / 2 - 0.15 * Seg_Len, Clock_Center_Y + Seg_Len / 2 + 3 * Seg_Len / 9, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }

    }




    //Segment 3 (Bas)
    if (Digits[digit_val][3]) {
        Fill_Col = Col_Vag_ON;
    }
    else {
        Fill_Col = Col_Vag_OFF;
    }

    //dessin des points

    //Segment à 3 LEDs
    if (Seg_LEDs == 3) {
        context.beginPath();
        context.arc(Clock_Center_X + digit_x - (0.18 * Seg_Len) - 5 * Seg_Len / 18, Clock_Center_Y + Seg_Len, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }

        context.beginPath();
        context.arc(Clock_Center_X + digit_x - (0.18 * Seg_Len), Clock_Center_Y + Seg_Len, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }

        context.beginPath();
        context.arc(Clock_Center_X + digit_x - (0.18 * Seg_Len) + 5 * Seg_Len / 18, Clock_Center_Y + Seg_Len, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }
    }
    else	//Segment à 4 LEDs
    {
        context.beginPath();
        context.arc(Clock_Center_X + digit_x - (0.18 * Seg_Len) - 1 * Seg_Len / 9, Clock_Center_Y + Seg_Len, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }

        context.beginPath();
        context.arc(Clock_Center_X + digit_x - (0.18 * Seg_Len) - 3 * Seg_Len / 9, Clock_Center_Y + Seg_Len, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }

        context.beginPath();
        context.arc(Clock_Center_X + digit_x - (0.18 * Seg_Len) + 1 * Seg_Len / 9, Clock_Center_Y + Seg_Len, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }

        context.beginPath();
        context.arc(Clock_Center_X + digit_x - (0.18 * Seg_Len) + 3 * Seg_Len / 9, Clock_Center_Y + Seg_Len, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }
    }

    //Segment 4 (SO)
    if (Digits[digit_val][4]) {
        Fill_Col = Col_Vag_ON;
    }
    else {
        Fill_Col = Col_Vag_OFF;
    }

    //dessin des points	

    //Segment à 3 LEDs
    if (Seg_LEDs == 3) {
        context.beginPath();
        context.arc(Clock_Center_X + digit_x - Seg_Len / 2 - 0.132 * Seg_Len, Clock_Center_Y + 14 * Seg_Len / 18, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }

        context.beginPath();
        context.arc(Clock_Center_X + digit_x - Seg_Len / 2 - 0.088 * Seg_Len, Clock_Center_Y + Seg_Len / 2, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }

        context.beginPath();
        context.arc(Clock_Center_X + digit_x - Seg_Len / 2 - 0.044 * Seg_Len, Clock_Center_Y + 4 * Seg_Len / 18, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }
    }
    else	//Segment à 4 LEDs
    {
        context.beginPath();
        context.arc(Clock_Center_X + digit_x - Seg_Len / 2 - 0.03 * Seg_Len, Clock_Center_Y + Seg_Len / 2 - 3 * Seg_Len / 9, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }

        context.beginPath();
        context.arc(Clock_Center_X + digit_x - Seg_Len / 2 - 0.07 * Seg_Len, Clock_Center_Y + Seg_Len / 2 - 1 * Seg_Len / 9, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }

        context.beginPath();
        context.arc(Clock_Center_X + digit_x - Seg_Len / 2 - 0.11 * Seg_Len, Clock_Center_Y + Seg_Len / 2 + 1 * Seg_Len / 9, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }

        context.beginPath();
        context.arc(Clock_Center_X + digit_x - Seg_Len / 2 - 0.15 * Seg_Len, Clock_Center_Y + Seg_Len / 2 + 3 * Seg_Len / 9, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }
    }


    //Segment 5 (NO)
    if (Digits[digit_val][5]) {
        Fill_Col = Col_Vag_ON;
    }
    else {
        Fill_Col = Col_Vag_OFF;
    }

    //dessin des points

    //Segment à 3 LEDs
    if (Seg_LEDs == 3) {
        context.beginPath();
        context.arc(Clock_Center_X + digit_x - Seg_Len / 2 + 0.132 * Seg_Len, Clock_Center_Y - 14 * Seg_Len / 18, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }

        context.beginPath();
        context.arc(Clock_Center_X + digit_x - Seg_Len / 2 + 0.088 * Seg_Len, Clock_Center_Y - Seg_Len / 2, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }

        context.beginPath();
        context.arc(Clock_Center_X + digit_x - Seg_Len / 2 + 0.044 * Seg_Len, Clock_Center_Y - 4 * Seg_Len / 18, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }

    }
    else	//Segment à 4 LEDs
    {
        context.beginPath();
        context.arc(Clock_Center_X + digit_x - Seg_Len / 2 + 0.15 * Seg_Len, Clock_Center_Y - Seg_Len / 2 - 3 * Seg_Len / 9, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }

        context.beginPath();
        context.arc(Clock_Center_X + digit_x - Seg_Len / 2 + 0.11 * Seg_Len, Clock_Center_Y - Seg_Len / 2 - 1 * Seg_Len / 9, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }

        context.beginPath();
        context.arc(Clock_Center_X + digit_x - Seg_Len / 2 + 0.07 * Seg_Len, Clock_Center_Y - Seg_Len / 2 + 1 * Seg_Len / 9, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }

        context.beginPath();
        context.arc(Clock_Center_X + digit_x - Seg_Len / 2 + 0.03 * Seg_Len, Clock_Center_Y - Seg_Len / 2 + 3 * Seg_Len / 9, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }
    }



    //Segment 6 (milieu)
    if (Digits[digit_val][6]) {
        Fill_Col = Col_Vag_ON;
    }
    else {
        Fill_Col = Col_Vag_OFF;
    }

    //dessin des points

    //Segment à 3 LEDs
    if (Seg_LEDs == 3) {

        context.beginPath();
        context.arc(Clock_Center_X + digit_x - 5 * Seg_Len / 18, Clock_Center_Y, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }

        context.beginPath();
        context.arc(Clock_Center_X + digit_x, Clock_Center_Y, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }

        context.beginPath();
        context.arc(Clock_Center_X + digit_x + 5 * Seg_Len / 18, Clock_Center_Y, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }
    }
    else	//Segment à 4 LEDs
    {
        context.beginPath();
        context.arc(Clock_Center_X + digit_x - 1 * Seg_Len / 9, Clock_Center_Y, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }

        context.beginPath();
        context.arc(Clock_Center_X + digit_x - 3 * Seg_Len / 9, Clock_Center_Y, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }

        context.beginPath();
        context.arc(Clock_Center_X + digit_x + 1 * Seg_Len / 9, Clock_Center_Y, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }

        context.beginPath();
        context.arc(Clock_Center_X + digit_x + 3 * Seg_Len / 9, Clock_Center_Y, Rayon_LED, 0, 2 * Math.PI, false);

        context.fillStyle = Fill_Col;
        context.fill();

        context.lineWidth = 1;
        context.strokeStyle = Col_Vag_Strk;
        if (Fill_Col == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
            context.stroke();
        }


    }

}

function Draw_DP() {

    //Dessin du point bas
    context.beginPath();
    context.arc(Clock_Center_X - 0.066 * Seg_Len, Clock_Center_Y + Seg_Len / 3, Rayon_LED, 0, 2 * Math.PI, false);

    if (Cur_Millisec < 500) {
        context.fillStyle = Col_Vag_OFF_BIS;
    }
    else {
        context.fillStyle = Col_Vag_ON;
    }

    context.fill();

    context.lineWidth = 1;
    context.strokeStyle = Col_Vag_Strk;

    if (context.fillStyle == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
        context.stroke();
    }

    //Dessin du point haut
    context.beginPath();
    context.arc(Clock_Center_X + 0.066 * Seg_Len, Clock_Center_Y - Seg_Len / 3, Rayon_LED, 0, 2 * Math.PI, false);

    if (Cur_Millisec < 500) {
        context.fillStyle = Col_Vag_OFF_BIS;
    }
    else {
        context.fillStyle = Col_Vag_ON;
    }

    context.fill();

    context.lineWidth = 1;
    context.strokeStyle = Col_Vag_Strk;

    if (context.fillStyle == Col_Vag_ON || Dont_Display_OFF_Stroke == false) {
        context.stroke();
    }

}
